import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import Forms from './components/Forms';

const TagsOuvidoriaCadastro = ({ isReadOnly = false, id: propId, hideHeader = false }) => {
  const { id: paramId } = useParams();
  const id = propId || paramId;
  const isEditing = !!id && !isReadOnly;
  const isViewing = isReadOnly;

  return (
    <Container fluid>
      {!hideHeader && (
        <Row>
          <Col md={12}>
            <PageHeader
              title=""
              routeSegments={[
                { name: 'Inicio' },
                { name: 'Tags da Ouvidoria', route: '/pages/tagsouvidoria' },
                {
                  name: isViewing ? 'Detalhes da Tag' : isEditing ? 'Editar Tag' : 'Nova Tag',
                },
              ]}
            />
          </Col>
        </Row>
      )}

      <Row>
        <Col md={12}>
          <Forms isReadOnly={isReadOnly} />
        </Col>
      </Row>
    </Container>
  );
};

export default TagsOuvidoriaCadastro;
